import PropTypes from 'prop-types'
import { Box, Paper, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'
import InboxIcon from '@mui/icons-material/Inbox'

const NoRecords = ({ message = 'No records found', description, icon, callout, sx }) => {
  const iconNode = icon === undefined ? <InboxIcon sx={{ fontSize: 52 }} /> : icon

  const content = (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={{ py: 5, px: 2, textAlign: 'center', ...(!callout && sx) }}
    >
      {iconNode && (
        <Box sx={{ mb: 1.5, color: 'text.disabled', lineHeight: 0 }}>
          {iconNode}
        </Box>
      )}
      <Typography variant="subtitle1" fontWeight={500} color="text.secondary">
        {message}
      </Typography>
      {description && (
        <Typography variant="body2" color="text.disabled" sx={{ mt: 0.5, maxWidth: 320 }}>
          {description}
        </Typography>
      )}
    </Box>
  )

  if (callout) {
    return (
      <Paper
        variant="outlined"
        sx={{
          width: '100%',
          borderStyle: 'dashed',
          borderColor: theme => alpha(theme.palette.primary.main, 0.4),
          bgcolor: theme => alpha(theme.palette.primary.main, 0.04),
          ...sx,
        }}
      >
        {content}
      </Paper>
    )
  }

  return content
}

NoRecords.propTypes = {
  message: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.node,
  callout: PropTypes.bool,
  sx: PropTypes.object,
}

export default NoRecords
